<template>
  <div
    id="app"
    data-theme="light"
  >
    <router-view />
    <Footer />
  </div>
</template>

<script>
import 'noty/src/themes/bootstrap-v4.scss'
import '@/sass/app.scss'

import Footer from '@/components/Layout/Footer'

export default {
  name: 'App',
  components: {
    Footer
  },
  mounted () {
    document.documentElement.setAttribute('data-theme', 'light')
  }
}
</script>
